import { ClinicPageScripts } from "@/helpers/seo-schema/ClinicPageScripts"
import { BlokProps, withStoryblokEditable } from "@helpers/StoryblokHelpers"
import { ClinicPageStoryblok } from "@storyblok-types"
import { StoryblokServerComponent } from "@storyblok/react/rsc"
import PageContainer from "@ui-library/layout/PageContainer"

interface ClinicPageProps {
  blok: BlokProps<ClinicPageStoryblok>["blok"]
  clinicId?: string
}

export const ClinicPage = ({ blok, clinicId }: ClinicPageProps) => {
  return (
    <>
      <PageContainer background={blok.background} extraHeight={false} {...withStoryblokEditable(blok)}>
        {blok.body?.map(nestedBlok => (
          <StoryblokServerComponent blok={nestedBlok} clinicId={clinicId} key={nestedBlok._uid} />
        ))}
      </PageContainer>
      {blok && <ClinicPageScripts blok={blok} />}
    </>
  )
}

export default ClinicPage
